import React from 'react';
import { Outlet } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { SettingsTabsNav } from './SettingsTabsNav';

export const SettingsLayout: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-indigo-600/10 border border-indigo-500/20 flex items-center justify-center text-indigo-400">
          <Settings className="w-5 h-5" />
        </div>
        <div>
          <h1 className="text-xl font-bold text-white tracking-tight">Account & Workspace Settings</h1>
          <p className="text-xs text-zinc-400">
            Manage your personal credentials, organization profile, security, team roster, and compliance verification
          </p>
        </div>
      </div>

      <SettingsTabsNav />

      <div className="pt-2">
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsLayout;
